import styled from 'styled-components';
import Colors from '@/constants/Colors';
import { font } from '@/shared/Activities/RealTimeActivity/Players/SortImagesActivity/sortImages.utils';
import HexOpacities from '@/constants/HexOpacities';

export const StyledQuestionCard = styled.div`
  display: flex;
  gap: 10px;
  position: relative;
  flex: 1;
  background-color: white;
  border: 1px solid ${Colors.border};
  border-radius: 10px;
  padding: 15px 20px;
  align-items: center;

  .question-card-translate-button {
    position: absolute;
    top: -13px;
    right: 43px;
    z-index: 1;

    &.ant-btn {
      background-color: white;
    }

    &.ant-btn-pink {
      background-color: ${Colors.pink};
      border-color: ${Colors.pink};
      color: white;

      &:hover {
        background-color: ${Colors.pink}${HexOpacities[80]};
      }
    }
  }

  .question-card-text {
    flex: 1;
    color: ${Colors.primary};
    font-family: ${font.family};
    font-weight: ${font.weightBold};
    text-align: center;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 5px;

    .showing-answer {
      color: ${Colors.pink} !important;
    }
  }

  .question-card-image {
    flex: 1;
    position: relative;
    height: 100px;

    > div > div {
      border-radius: 10px;
      overflow: hidden;
    }
  }
`;
